/* Copyright 2013 - 2024 Waiterio LLC */
import React from 'react'
import { Navigate, useLocation } from 'react-router'
import getBrowserLanguage from '@monorepool/shared/getBrowserLanguage.js'

export const paths = [{ path: '/' }, { path: '/docs/' }]

const HomeRedirect = () => {
  const locale = getBrowserLanguage() || 'en'
  let location = useLocation()
  let querystring = location.search
  return <Navigate exact to={`/docs/${locale}${querystring}`} />
}

export default HomeRedirect
